module.exports = __webpack_public_path__ + "img/3-2.facd52d9.png";